import { trackEvent } from './trackEvent';

export function trackPageView(
  pageName: string,
  properties: Record<string, unknown> = {},
) {
  // Mixpanel assumes `id` refers to `userId`, so let's
  // rename to `listing_id` to keep things easier to parse.
  const pageProperties = { ...properties };
  if (pageProperties?.id) {
    pageProperties.listing_id = pageProperties.id;
    delete pageProperties.id;
  }

  trackEvent(`Page View: ${pageName}`, pageProperties);
}
